import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconChevronRightSvg } from "./IconChevronRightSvg.mjs";
const IconChevronRight = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconChevronRightSvg, ...iconProps });
};
export {
  IconChevronRight
};
